// pages/FormViewerPage/components/ClaimModeOptions.tsx — 2 pilihan WA vs klaim ongkir (split dari HerbalShippingClaimCard.tsx)
import React from 'react';
import ChatBubbleIcon from '../../../components/icons/ChatBubbleIcon';
import TagIcon from '../../../components/icons/TagIcon';

interface ClaimModeOptionsProps {
    claimMode: 'wa' | 'claim_ongkir';
    onClaimModeChange: (mode: 'wa' | 'claim_ongkir') => void;
    promoTitleShort: string;
    promoDescShort: string;
}

export const ClaimModeOptions: React.FC<ClaimModeOptionsProps> = ({ claimMode, onClaimModeChange, promoTitleShort, promoDescShort }) => (
    <div className="grid grid-cols-2 gap-2">
        {/* Opsi 1: WhatsApp */}
        <div
            onClick={() => onClaimModeChange('wa')}
            className={`p-2.5 rounded-xl border-2 cursor-pointer transition-all duration-150 ${
                claimMode === 'wa'
                    ? 'border-slate-600 bg-slate-50 dark:bg-slate-900/60 shadow-xs'
                    : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-slate-400'
            }`}
        >
            <div className="flex items-center gap-2">
                <div
                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 ${
                        claimMode === 'wa' ? 'border-slate-600 bg-slate-600' : 'border-slate-400'
                    }`}
                >
                    {claimMode === 'wa' && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                </div>
                <div className="min-w-0">
                    <p className="text-xs font-bold text-slate-900 dark:text-white leading-tight flex items-center gap-1">
                        <ChatBubbleIcon className="w-3.5 h-3.5 shrink-0" /> Tanpa Diskon Ongkir
                    </p>
                    <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">
                        Ongkir tetap penuh, atur alamat lewat chat CS
                    </p>
                </div>
            </div>
        </div>

        {/* Opsi 2: Klaim Ongkir */}
        <div
            onClick={() => onClaimModeChange('claim_ongkir')}
            className={`p-2.5 rounded-xl border-2 cursor-pointer transition-all duration-150 ${
                claimMode === 'claim_ongkir'
                    ? 'border-emerald-600 bg-emerald-50 dark:bg-emerald-950/40 shadow-xs'
                    : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-slate-400'
            }`}
        >
            <div className="flex items-center gap-2">
                <div
                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 ${
                        claimMode === 'claim_ongkir' ? 'border-emerald-600 bg-emerald-600' : 'border-slate-400'
                    }`}
                >
                    {claimMode === 'claim_ongkir' && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                </div>
                <div className="min-w-0">
                    <p className="text-xs font-bold text-emerald-700 dark:text-emerald-400 leading-tight flex items-center gap-1">
                        <TagIcon className="w-3.5 h-3.5 shrink-0" /> {promoTitleShort}
                    </p>
                    <p className="text-[10px] text-slate-500 dark:text-slate-400 leading-tight">
                        {promoDescShort}
                    </p>
                </div>
            </div>
        </div>
    </div>
);
